<template>
  <Teleport to="body">
    <Transition name="search-fade">
      <div v-if="visible" class="global-search-overlay" @click.self="closeSearch">
        <div class="global-search-container">
          <!-- 搜索头部 -->
          <div class="search-header">
            <div class="search-input-wrapper">
              <svg class="search-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg ">
                <path d="M21 21L16.65 16.65M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <input
                ref="searchInput"
                v-model="searchKeyword"
                type="text"
                placeholder="搜索产品、解决方案、服务..."
                @input="handleSearch"
                @keydown.esc="closeSearch"
                @keydown.enter="handleEnter"
              />
              <div v-if="searchKeyword" class="clear-btn" @click="clearSearch">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg ">
                  <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
            <button class="close-btn" @click="closeSearch">
              <span>ESC</span>
            </button>
          </div>

          <!-- 搜索内容区域 -->
          <div class="search-content">
            <!-- 无搜索时显示热门搜索和快速入口 -->
            <template v-if="!searchKeyword">
              <div class="search-section">
                <div class="section-header">
                  <svg class="section-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg ">
                    <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="#FF6B35" stroke="#FF6B35" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <span>热门搜索</span>
                </div>
                <div class="hot-keywords">
                  <span
                    v-for="keyword in hotKeywords"
                    :key="keyword"
                    class="hot-keyword-tag"
                    @click="selectHotKeyword(keyword)"
                  >
                    {{ keyword }}
                  </span>
                </div>
              </div>

              <div class="search-section">
                <div class="section-header">
                  <svg class="section-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg ">
                    <path d="M13 2L3 14H12L11 22L21 10H12L13 2Z" fill="#3B82F6" stroke="#3B82F6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <span>快速入口</span>
                </div>
                <div class="quick-links">
                  <div
                    v-for="link in quickLinks"
                    :key="link.path"
                    class="quick-link-card"
                    @click="navigateTo(link.path)"
                  >
                    <div class="quick-link-icon" :class="link.icon">
                      <svg v-if="link.icon === 'product'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg ">
                        <path d="M21 16V8.00002C20.9996 7.6493 20.9071 7.30483 20.7315 7.00119C20.556 6.69754 20.3037 6.44539 20 6.27002L13 2.27002C12.696 2.09449 12.3511 2.00208 12 2.00208C11.6489 2.00208 11.304 2.09449 11 2.27002L4 6.27002C3.69626 6.44539 3.44398 6.69754 3.26846 7.00119C3.09294 7.30483 3.00036 7.6493 3 8.00002V16C3.00036 16.3508 3.09294 16.6952 3.26846 16.9989C3.44398 17.3025 3.69626 17.5547 4 17.73L11 21.73C11.304 21.9056 11.6489 21.998 12 21.998C12.3511 21.998 12.696 21.9056 13 21.73L20 17.73C20.3037 17.5547 20.556 17.3025 20.7315 16.9989C20.9071 16.6952 20.9996 16.3508 21 16Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M3.27002 6.96002L12 12.01L20.73 6.96002" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M12 22.08V12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <svg v-if="link.icon === 'solution'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg ">
                        <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M2 17L12 22L22 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M2 12L12 17L22 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <svg v-if="link.icon === 'about'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg ">
                        <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M12 16V12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M12 8H12.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </div>
                    <span>{{ link.name }}</span>
                  </div>
                </div>
              </div>

              <!-- 推荐产品 -->
              <div class="search-section">
                <div class="section-header">
                  <svg class="section-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg ">
                    <path d="M20.84 4.61C20.3292 4.099 19.7228 3.69365 19.0554 3.41708C18.3879 3.14052 17.6725 2.99817 16.95 2.99817C16.2275 2.99817 15.5121 3.14052 14.8446 3.41708C14.1772 3.69365 13.5708 4.099 13.06 4.61L12 5.67L10.94 4.61C9.9083 3.57831 8.50903 2.99871 7.05 2.99871C5.59096 2.99871 4.19169 3.57831 3.16 4.61C2.1283 5.64169 1.54871 7.04097 1.54871 8.5C1.54871 9.95903 2.1283 11.3583 3.16 12.39L4.22 13.45L12 21.23L19.78 13.45L20.84 12.39C21.351 11.8792 21.7563 11.2728 22.0329 10.6054C22.3095 9.93789 22.4518 9.22249 22.4518 8.5C22.4518 7.77751 22.3095 7.06211 22.0329 6.39464C21.7563 5.72718 21.351 5.12075 20.84 4.61V4.61Z" fill="#EC4899" stroke="#EC4899" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <span>推荐产品</span>
                </div>
                <div class="recommend-products">
                  <div
                    v-for="product in recommendProducts"
                    :key="product.id"
                    class="recommend-product-card"
                    @click="navigateTo(product.path)"
                  >
                    <div class="product-icon">
                      <img :src="product.icon" :alt="product.name" />
                    </div>
                    <div class="product-info">
                      <h4>{{ product.name }}</h4>
                      <p>{{ product.description }}</p>
                    </div>
                    <div class="product-category">{{ product.category }}</div>
                  </div>
                </div>
              </div>
            </template>

            <!-- 搜索结果 -->
            <template v-else>
              <div v-if="hasResults" class="search-results">
                <!-- 产品结果 -->
                <div v-if="searchResults.products.length" class="result-section">
                  <div class="result-header">
                    <span class="result-title">产品</span>
                    <span class="result-count">{{ searchResults.products.length }} 个结果</span>
                  </div>
                  <div class="result-list">
                    <div
                      v-for="product in searchResults.products"
                      :key="product.id"
                      class="result-item"
                      @click="navigateTo(product.path)"
                    >
                      <div class="result-icon product-type">
                        <img :src="product.icon" :alt="product.name" />
                      </div>
                      <div class="result-info">
                        <h4 v-html="highlightKeyword(product.name)"></h4>
                        <p v-html="highlightKeyword(product.description)"></p>
                      </div>
                      <div class="result-category">{{ product.category }}</div>
                      <svg class="result-arrow" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg ">
                        <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </div>
                  </div>
                </div>

                <!-- 解决方案结果 -->
                <div v-if="searchResults.solutions.length" class="result-section">
                  <div class="result-header">
                    <span class="result-title">解决方案</span>
                    <span class="result-count">{{ searchResults.solutions.length }} 个结果</span>
                  </div>
                  <div class="result-list">
                    <div
                      v-for="solution in searchResults.solutions"
                      :key="solution.id"
                      class="result-item"
                      @click="navigateTo(solution.path)"
                    >
                      <div class="result-icon solution-type">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg ">
                          <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M2 17L12 22L22 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M2 12L12 17L22 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </div>
                      <div class="result-info">
                        <h4 v-html="highlightKeyword(solution.name)"></h4>
                        <p v-html="highlightKeyword(solution.description)"></p>
                      </div>
                      <div class="result-category">{{ solution.category }}</div>
                      <svg class="result-arrow" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg ">
                        <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </div>
                  </div>
                </div>

                <!-- 服务结果 -->
                <div v-if="searchResults.services.length" class="result-section">
                  <div class="result-header">
                    <span class="result-title">服务与支持</span>
                    <span class="result-count">{{ searchResults.services.length }} 个结果</span>
                  </div>
                  <div class="result-list">
                    <div
                      v-for="service in searchResults.services"
                      :key="service.id"
                      class="result-item"
                      @click="navigateTo(service.path)"
                    >
                      <div class="result-icon service-type">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg ">
                          <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M9.09 9C9.3251 8.33167 9.78915 7.76811 10.4 7.40913C11.0108 7.05016 11.7289 6.91894 12.4272 7.03871C13.1255 7.15849 13.7588 7.52152 14.2151 8.06353C14.6713 8.60553 14.9211 9.29152 14.92 10C14.92 12 11.92 13 11.92 13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M12 17H12.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </div>
                      <div class="result-info">
                        <h4 v-html="highlightKeyword(service.name)"></h4>
                        <p v-html="highlightKeyword(service.description)"></p>
                      </div>
                      <div class="result-category">{{ service.category }}</div>
                      <svg class="result-arrow" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg ">
                        <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 无结果提示 -->
              <div v-else class="no-results">
                <div class="no-results-icon">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg ">
                    <path d="M21 21L16.65 16.65M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M8 8L14 14M14 8L8 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
                <h3>未找到相关结果</h3>
                <p>抱歉，没有找到与 "<strong>{{ searchKeyword }}</strong>" 相关的内容</p>
                <div class="no-results-tips">
                  <span>建议：</span>
                  <ul>
                    <li>检查您的输入是否正确</li>
                    <li>尝试使用其他关键词</li>
                    <li>使用更通用的搜索词</li>
                  </ul>
                </div>
              </div>
            </template>
          </div>

          <!-- 底部提示 -->
          <div class="search-footer">
            <div class="keyboard-hints">
              <!-- <span class="hint">
                <kbd>↑</kbd><kbd>↓</kbd> 导航
              </span> -->
              <span class="hint">
                <kbd>Enter</kbd> 选择
              </span>
              <span class="hint">
                <kbd>ESC</kbd> 关闭
              </span>
            </div>
            <div class="powered-by">
              瑞和云图 · 全局搜索
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script>
import { searchAll, getHotKeywords, getQuickLinks, searchData } from '../data/searchData';

export default {
  name: 'GlobalSearch',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close'],
  data() {
    return {
      searchKeyword: '',
      searchResults: {
        products: [],
        solutions: [],
        services: []
      },
      hotKeywords: [],
      quickLinks: [],
      recommendProducts: []
    };
  },
  computed: {
    hasResults() {
      return (
        this.searchResults.products.length > 0 ||
        this.searchResults.solutions.length > 0 ||
        this.searchResults.services.length > 0
      );
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.$refs.searchInput?.focus();
        });
        // 禁止背景滚动
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    }
  },
  mounted() {
    this.hotKeywords = getHotKeywords();
    this.quickLinks = getQuickLinks();
    // 推荐产品取前6个
    this.recommendProducts = searchData.products.slice(0, 6);
  },
  methods: {
    closeSearch() {
      this.searchKeyword = '';
      this.searchResults = { products: [], solutions: [], services: [] };
      this.$emit('close');
    },
    clearSearch() {
      this.searchKeyword = '';
      this.searchResults = { products: [], solutions: [], services: [] };
      this.$refs.searchInput?.focus();
    },
    handleSearch() {
      this.searchResults = searchAll(this.searchKeyword);
    },
    selectHotKeyword(keyword) {
      this.searchKeyword = keyword;
      this.handleSearch();
    },
    navigateTo(path) {
      this.$router.push(path);
      this.closeSearch();
    },
    handleEnter() {
      // 如果有搜索结果，跳转到第一个结果
      if (this.searchResults.products.length) {
        this.navigateTo(this.searchResults.products[0].path);
      } else if (this.searchResults.solutions.length) {
        this.navigateTo(this.searchResults.solutions[0].path);
      } else if (this.searchResults.services.length) {
        this.navigateTo(this.searchResults.services[0].path);
      }
    },
    highlightKeyword(text) {
      if (!this.searchKeyword) return text;
      const regex = new RegExp(`(${this.searchKeyword})`, 'gi');
      return text.replace(regex, '<mark>$1</mark>');
    }
  }
};
</script>

<style scoped>
/* 过渡动画 */
.search-fade-enter-active,
.search-fade-leave-active {
  transition: all 0.3s ease;
}

.search-fade-enter-from,
.search-fade-leave-to {
  opacity: 0;
}

.search-fade-enter-from .global-search-container,
.search-fade-leave-to .global-search-container {
  transform: translateY(-20px) scale(0.98);
  opacity: 0;
}

/* 遮罩层 */
.global-search-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(8px);
  z-index: 9999;
  display: flex;
  justify-content: center;
  padding-top: 80px;
  overflow-y: auto;
}

/* 搜索容器 */
.global-search-container {
  width: 780px;
  max-width: 90vw;
  max-height: calc(100vh - 120px);
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 16px;
  box-shadow: 
    0 25px 50px -12px rgba(0, 0, 0, 0.25),
    0 0 0 1px rgba(255, 255, 255, 0.1);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: transform 0.3s ease, opacity 0.3s ease;
}

/* 搜索头部 */
.search-header {
  display: flex;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e5e7eb;
  background: #fff;
}

.search-input-wrapper {
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
}

.search-input-wrapper .search-icon {
  position: absolute;
  left: 16px;
  width: 22px;
  height: 22px;
  color: #9ca3af;
  pointer-events: none;
}

.search-input-wrapper input {
  width: 100%;
  height: 34px;
  padding: 0 48px 0 52px;
  font-size: 14px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  outline: none;
  transition: all 0.2s ease;
  /* background: #f9fafb; */
  color: #333;
}

.search-input-wrapper input:focus {
  /* border-color: #3b82f6; */
  background: #fff;
  /* box-shadow: 0 4px 16px rgba(59, 130, 246, 0.12); */
}
.search-input-wrapper input:hover {
  /* border-color: #3b82f6; */
  background: #fff;
  box-shadow: 0 4px 16px rgba(59, 130, 246, 0.12);
}

.search-input-wrapper input::placeholder {
  color: #9ca3af;
}

.clear-btn {
  position: absolute;
  right: 5px;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #9ca3af;
  transition: all 0.2s ease;
  border-radius: 6px;
}

.clear-btn:hover {
  /* background: #f3f4f6; */
  color: #6b7280;
}

.clear-btn svg {
  width: 16px;
  height: 16px;
}

.close-btn {
  margin-left: 16px;
  padding: 8px 12px;
  background: #f3f4f6;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  transition: all 0.2s ease;
}

.close-btn:hover {
  background: #e5e7eb;
  color: #374151;
}

/* 搜索内容区域 */
.search-content {
  flex: 1;
  overflow-y: auto;
  padding: 24px;
}

/* 搜索分区 */
.search-section {
  margin-bottom: 28px;
}

.search-section:last-child {
  margin-bottom: 0;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
}

.section-icon {
  width: 18px;
  height: 18px;
}

/* 热门搜索 */
.hot-keywords {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.hot-keyword-tag {
  padding: 8px 16px;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  border: 1px solid #bae6fd;
  border-radius: 20px;
  font-size: 13px;
  color: #0369a1;
  cursor: pointer;
  transition: all 0.2s ease;
}

.hot-keyword-tag:hover {
  background: linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%);
  border-color: #7dd3fc;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(14, 165, 233, 0.15);
}

/* 快速入口 */
.quick-links {
  display: flex;
  gap: 16px;
}

.quick-link-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 20px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.quick-link-card:hover {
  /* border-color: #3b82f6; */
  box-shadow: 0 4px 16px rgba(59, 130, 246, 0.12);
  transform: translateY(-2px);
}

.quick-link-icon {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  color: #fff;
}

.quick-link-icon.product {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
}

.quick-link-icon.solution {
  background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
}

.quick-link-icon.about {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
}

.quick-link-icon svg {
  width: 22px;
  height: 22px;
}

.quick-link-card span {
  font-size: 14px;
  font-weight: 500;
  color: #374151;
}

/* 推荐产品 */
.recommend-products {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.recommend-product-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.recommend-product-card:hover {
  /* border-color: #3b82f6; */
  box-shadow: 0 4px 16px rgba(59, 130, 246, 0.12);
  transform: translateY(-2px);
}

.recommend-product-card .product-icon {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
}

.recommend-product-card .product-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.recommend-product-card .product-info {
  flex: 1;
  min-width: 0;
}

.recommend-product-card .product-info h4 {
  font-size: 14px;
  font-weight: 500;
  color: #1f2937;
  margin: 0 0 4px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.recommend-product-card .product-info p {
  font-size: 12px;
  color: #6b7280;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.recommend-product-card .product-category {
  padding: 4px 8px;
  background: #f3f4f6;
  border-radius: 4px;
  font-size: 11px;
  color: #6b7280;
  white-space: nowrap;
}

/* 搜索结果 */
.result-section {
  margin-bottom: 24px;
}

.result-section:last-child {
  margin-bottom: 0;
}

.result-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e5e7eb;
}

.result-title {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
}

.result-count {
  font-size: 12px;
  color: #9ca3af;
}

.result-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.result-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 16px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.result-item:hover {
  /* border-color: #3b82f6; */
  background: #f8fafc;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.1);
}

.result-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  flex-shrink: 0;
}

.result-icon.product-type {
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
}

.result-icon.product-type img {
  width: 28px;
  height: 28px;
  object-fit: contain;
}

.result-icon.solution-type {
  background: linear-gradient(135deg, #ede9fe 0%, #ddd6fe 100%);
  color: #7c3aed;
}

.result-icon.solution-type svg {
  width: 20px;
  height: 20px;
}

.result-icon.service-type {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  color: #059669;
}

.result-icon.service-type svg {
  width: 20px;
  height: 20px;
}

.result-info {
  flex: 1;
  min-width: 0;
}

.result-info h4 {
  font-size: 14px;
  font-weight: 500;
  color: #1f2937;
  margin: 0 0 4px 0;
}

.result-info p {
  font-size: 12px;
  color: #6b7280;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.result-info h4 :deep(mark),
.result-info p :deep(mark) {
  background: linear-gradient(120deg, #fef08a 0%, #fde047 100%);
  color: #854d0e;
  padding: 0 2px;
  border-radius: 2px;
}

.result-category {
  padding: 4px 10px;
  background: #f3f4f6;
  border-radius: 6px;
  font-size: 12px;
  color: #6b7280;
  white-space: nowrap;
}

.result-arrow {
  width: 18px;
  height: 18px;
  color: #d1d5db;
  flex-shrink: 0;
  transition: all 0.2s ease;
}

.result-item:hover .result-arrow {
  /* color: #3b82f6; */
  transform: translateX(4px);
}

/* 无结果提示 */
.no-results {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 48px 24px;
  text-align: center;
}

.no-results-icon {
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f3f4f6;
  border-radius: 50%;
  margin-bottom: 20px;
}

.no-results-icon svg {
  width: 40px;
  height: 40px;
  color: #9ca3af;
}

.no-results h3 {
  font-size: 24px;
  font-weight: 600;
  color: #374151;
  margin: 0 0 8px 0;
}

.no-results p {
  font-size: 14px;
  color: #6b7280;
  margin: 0 0 24px 0;
}

.no-results p strong {
  /* color: #3b82f6; */
}

.no-results-tips {
  text-align: left;
  padding: 16px 20px;
  background: #f9fafb;
  border-radius: 10px;
  font-size: 13px;
  color: #6b7280;
}

.no-results-tips span {
  font-weight: 500;
  color: #374151;
}

.no-results-tips ul {
  margin: 8px 0 0 0;
  padding-left: 20px;
}

.no-results-tips li {
  margin-bottom: 4px;
}

/* 底部提示 */
.search-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 24px;
  border-top: 1px solid #e5e7eb;
  background: #f9fafb;
}

.keyboard-hints {
  display: flex;
  gap: 16px;
}

.hint {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #9ca3af;
}

.hint kbd {
  padding: 2px 6px;
  background: #fff;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-family: inherit;
  font-size: 11px;
  color: #6b7280;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.powered-by {
  font-size: 12px;
  color: #9ca3af;
}

/* 滚动条样式 */
.search-content::-webkit-scrollbar {
  width: 6px;
}

.search-content::-webkit-scrollbar-track {
  background: transparent;
}

.search-content::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 3px;
}

.search-content::-webkit-scrollbar-thumb:hover {
  background: #9ca3af;
}

/* 移动端响应式设计 */
@media (max-width: 768px) {
  .global-search-container {
    width: 95vw;
    max-width: 95vw;
    max-height: calc(100vh - 100px);
  }
  
  .search-header {
    padding: 16px;
  }
  
  .search-input-wrapper input {
    height: 44px;
    font-size: 16px;
    padding: 0 44px 0 44px;
  }
  
  .search-content {
    padding: 16px;
  }
  
  .quick-links {
    flex-direction: column;
    gap: 12px;
  }
  
  .recommend-products {
    grid-template-columns: 1fr;
    gap: 10px;
  }
  
  .recommend-product-card {
    padding: 12px;
    gap: 10px;
  }
  
  .recommend-product-card .product-icon {
    width: 36px;
    height: 36px;
  }
  
  .recommend-product-card .product-info h4 {
    font-size: 13px;
  }
  
  .recommend-product-card .product-info p {
    font-size: 11px;
  }
  
  .recommend-product-card .product-category {
    font-size: 10px;
    padding: 3px 6px;
  }
  
  .result-item {
    padding: 12px;
    gap: 12px;
  }
  
  .result-info h4 {
    font-size: 13px;
  }
  
  .result-info p {
    font-size: 11px;
  }
  
  .search-footer {
    padding: 12px 16px;
    flex-direction: column;
    gap: 10px;
  }
  
  .keyboard-hints {
    flex-wrap: wrap;
    justify-content: center;
    gap: 12px;
  }
}
</style>